import { Role } from "@bl-enum/role";
import { take } from "rxjs/operators";
import * as i0 from "@angular/core";
import * as i1 from "../user/user.service";
import * as i2 from "../authentication/authentication.service";
import * as i3 from "@angular/router";
export class AuthRoleGuardGuard {
    constructor(userService, auth, router) {
        this.userService = userService;
        this.auth = auth;
        this.router = router;
    }
    canActivate() {
        return new Promise((resolve) => {
            this.userService
                .getIsAdminUser()
                .pipe(take(1))
                .subscribe((res) => {
                if (res) {
                    resolve(true);
                }
                else {
                    this.userService
                        .getUserByMail(this.auth.msalService.getAccount().userName)
                        .subscribe((res) => {
                        if (res && res.role === Role.ADMIN) {
                            resolve(true);
                        }
                        else {
                            this.userService.setIsAdminUser(false);
                            this.router.navigate(["home"]);
                            resolve(false);
                        }
                    }, () => {
                        this.userService.setIsAdminUser(false);
                        this.router.navigate(["home"]);
                        resolve(false);
                    });
                }
            });
        });
    }
}
AuthRoleGuardGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthRoleGuardGuard_Factory() { return new AuthRoleGuardGuard(i0.ɵɵinject(i1.UserService), i0.ɵɵinject(i2.AuthenticationService), i0.ɵɵinject(i3.Router)); }, token: AuthRoleGuardGuard, providedIn: "root" });
